    import React from 'react';

const SkeletonOrderItems = ({ type = 'item' }) => {
  if (type === 'order') {
    return (
      <div className="w-full max-w-2xl mx-auto bg-white rounded-lg p-8 shadow animate-pulse">
        <div className="h-6 bg-gray-200 rounded w-1/2 mb-5" />
        <div className="flex flex-col gap-4">
          {[...Array(3)].map((_,i) => <SkeletonOrderItems type="item" key={i} />)}
        </div>
        <div className="mt-6 h-6 bg-gray-100 rounded w-1/3" />
      </div>
    );
  }
  return (
    <div className="flex items-center gap-4 p-3 bg-gray-50 rounded-lg border border-gray-200 animate-pulse">
      <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-lg bg-gray-200" />
      <div className="flex-1 min-w-0">
        <div className="h-4 bg-gray-200 rounded w-2/3 mb-2" />
        <div className="h-4 bg-gray-100 rounded w-1/3 mb-2" />
        <div className="h-3 bg-gray-100 rounded w-2/4 mb-1" />
      </div>
      <div className="w-16 h-6 bg-gray-200 rounded" />
    </div>
  );
};

export default SkeletonOrderItems;
